import $ from 'jquery';
import _ from 'underscore';
import BaseView from '../../core/baseView';
import AddressCheckAddressModel from './addressCheckAddressModel';
import AddressCheckAddressParser from './addressCheckAddressParser';
import AddressCheckService from './addressCheckService';
import AddressCheckView from './addressCheckView';
import { get as t } from '../../../home24/core/translation';
import AddressCheckEvents from '../../tracking/common/AddressCheckEvents';
import AddressCheckViewModel from './addressCheckViewModel';
import * as registry from '../../../home24/core/registry';

export default BaseView.extend({
  events: {
    'change input[name=city]': '_onParentFormSubmit',
    'change input[name=zip]': function() {
      this._onParentFormSubmit();
      this.fixZipForNL();
    },
    'change input[name=street]': '_onParentFormSubmit',
    'change input[name=default_billing]': '_onParentFormSubmit',
    'change input[name=default_shipping]': '_onParentFormSubmit'
  },

  isHandlerBound: false,

  initialize: function(options) {
    this.$scope = options.scope;
    this._service = new AddressCheckService();
    this._viewModel = new AddressCheckViewModel();

    this.bind();
    this._insertSpinnerIntoParentForm();
    this._hideSpinner();

    // Execute it for initial datas.
    // ex. address edit forms
    this.fixZipForNL();
  },

  fixZipForNL: function() {
    this.$el.normalizeZipCodeForNL();
  },

  bind: function() {
    this.isHandlerBound = true;
  },

  unbind: function() {
    this.isHandlerBound = false;
  },

  submitParentForm: function() {
    this.unbind();
    this.$el.submit();
  },

  _onParentFormSubmit: function() {
    if (this.isHandlerBound === false) {
      return false;
    }

    if (!this._isAddressFieldsFilled()) {
      return false;
    }

    if (this._view) {
      this._view.destroy();
    }

    this._showSpinner();
    this._service.sendRequest(
      this._getAddressDataStringFromParentForm(),
      $.proxy(this._onRequestSucceed, this),
      $.proxy(this._onRequestFailed, this)
    );

    return false;
  },

  _insertSpinnerIntoParentForm: function() {
    var buttonsContainer = this.$el.find('.form__buttons');
    var spinnerHtml =
      '<div id="address-check-spinner" class="svg-preloader pull-right"></div>';

    buttonsContainer.html(spinnerHtml + buttonsContainer.html());
  },

  _showSpinner: function() {
    this.$el.find('button[type=submit]').hide();
    this.$el.find('#address-check-spinner').show();
  },

  _hideSpinner: function() {
    this.$el.find('#address-check-spinner').hide();
    this.$el.find('button[type=submit]').show();
  },

  _onRequestSucceed: function(data) {
    var addresses;
    var ownAddress = this._getOwnAddress();
    var childViewScope;

    this._hideSpinner();
    addresses = this._parseResponse(data);

    if (data.status === 'NO_ADDRESS_IN_YOUR_COUNTRY') {
      $.validator.addMethod(
        'invalid',
        function() {
          return false;
        },
        t('ui.input.validation.country.wrong')
      );

      this.$el.find('input[name=zip]').rules('add', {
        invalid: { invalid: true }
      });
      this.$el.find('input[name=zip]').valid();
      this.$el.find('input[name=zip]').valid();

      return false;
    } else {
      this.$el.find('input[name=zip]').rules('remove', 'invalid');
      this.$el.find('input[name=zip]').valid();
      this.$el.find('input[name=zip]').valid();
    }

    // If no match or perfect match returned
    if (
      addresses.length === 0 ||
      ((addresses.length === 1 && addresses[0].get('ownAddress') === true) ||
        data.status === 'UNKNOWN_ERROR')
    ) {
      return true;
    }

    this.tracking = new AddressCheckEvents({
      googleResponse: _.pluck(data.results, 'formatted_address')
    });

    this.tracking.trackWrongAddressTyped();

    // if AB test says to not display results
    if (!registry.get('addressCheckEnabled')) {
      return true;
    }

    this._viewModel.set({
      addresses: addresses,
      ownAddress: ownAddress,
      originalResponse: data
    });

    childViewScope =
      this.$scope.find('.customer-address-finder').length === 1
        ? this.$scope.find('.customer-address-finder')[0]
        : this.$scope.find('.customer-address-finder')[1];

    this._view = new AddressCheckView({
      el: childViewScope,
      parentScope: this
    });

    this._view.showDialog(this._viewModel, this._onNewAddressSelected, this);
    this.tracking.trackAddressCheckShow();
    this._bindEventsForTracking();

    return true;
  },

  _bindEventsForTracking: function() {
    this._bindTrackFormEvent();
    this._bindTrackAddressInputsEvent();
  },

  _unbindEventsForTracking: function() {
    this.$el.off('submit.track_address_form');
    this._getAddressInputs().off('change.tracking_address_input');
  },

  _bindTrackFormEvent: function() {
    this.$el.on(
      'submit.track_address_form',
      $.proxy(this._onChangeTrackingFormSumbit, this)
    );
  },

  _bindTrackAddressInputsEvent: function() {
    this._getAddressInputs().on(
      'change.tracking_address_input',
      $.proxy(this._onChangeTrackingAddressInput, this)
    );
  },

  _onChangeTrackingFormSumbit: function() {
    this.tracking.trackOldAddressKept();
    this._unbindEventsForTracking();
  },

  _onChangeTrackingAddressInput: function() {
    this.tracking.trackAddressNewInput();
    this._unbindEventsForTracking();
  },

  _onNewAddressSelected: function(model) {
    this.tracking.trackGoogleAddressSelected();
    this._unbindEventsForTracking();
    this._setDataToParentForm(model);
  },

  _getAddressInputs: function() {
    return this.$el.find('input').filter(function(index, input) {
      var names = ['street', 'zip', 'city'];

      return _.contains(names, input.name);
    });
  },

  closeSubViews: function() {
    if (this._view) {
      this._view.destroy();
    }
  },

  _onRequestFailed: function() {
    this._hideSpinner();
    this.submitParentForm();
  },

  _getOwnAddress: function() {
    var form = this.$el;
    var model = new AddressCheckAddressModel();

    model.set('index', 0);
    model.set('zip', form.find('input[name=zip]').val());
    model.set('street', form.find('input[name=street]').val());
    model.set('streetAdd', form.find('input[name=additional]').val());
    model.set('city', form.find('input[name=city]').val());
    model.set('ownAddress', true);
    model.set('suggestedAddress', false);
    model.set('full', model.toString());

    return model;
  },

  _setDataToParentForm: function(model) {
    var form = this.$el;

    form.find('input[name=zip]').val(model.get('zip'));
    form.find('input[name=street]').val(model.get('street'));
    form.find('input[name=additional]').val(model.get('streetAdd'));
    form.find('input[name=city]').val(model.get('city'));

    form.valid();
    form.valid();
  },

  _getAddressDataStringFromParentForm: function() {
    var form = this.$el;
    var addressType;

    var isShipping = form.find('input[name=default_shipping]').prop('checked');
    var isBilling = form.find('input[name=default_billing]').prop('checked');

    switch (true) {
      case isShipping && !isBilling:
        addressType = 'shippingaddress';
        break;

      case !isShipping && isBilling:
        addressType = 'billingaddress';
        break;

      default:
        addressType = '';
    }

    return {
      addressType: addressType,
      street: form.find('input[name=street]').val(),
      streetAdd: form.find('input[name=additional]').val(),
      zip: form.find('input[name=zip]').val(),
      city: form.find('input[name=city]').val()
    };
  },

  _isAddressFieldsFilled: function() {
    var form = this.$el;

    return (
      form.find('input[name=street]').val() &&
      form.find('input[name=zip]').val() &&
      form.find('input[name=city]').val()
    );
  },

  _parseResponse: function(records) {
    return new AddressCheckAddressParser(records, this._getOwnAddress());
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/helpers/addressCheck/addressCheckViewController.js
 **/